import * as React from 'react';

import { 
  GlobalPrivateState,
  QueryParemeterPayload,
  removeQueryParam, 
  addFilterParam,
} from '../../../../api';
import { connect } from 'react-redux';
import { assign as _assign } from 'lodash';
import { remove as _remove } from 'lodash';
import classNames from 'classnames';
import './TroughFilterLarge.scss';
import Button from 'reactstrap/lib/Button';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './TroughFilterLarge.messages';
import TroughFilterFormOr from './TroughFilterTypes/troughFilterOr';
import { filterArtData } from 'src/api';
import { filterOverflowData, filterBackwallData, filterFormData } from './../../../../api/models/FilterForm/filter-form.data';
import TroughFilterFormAnd from './TroughFilterTypes/troughFilterAnd';

export interface TroughFilterLargeProps {
  dispatch: any;
  params: QueryParemeterPayload;
}

export interface TroughFilterLargeState {
  filter?: QueryParemeterPayload;
}

export class TroughFilterLargePartial extends React.Component<TroughFilterLargeProps, TroughFilterLargeState> {
  
  constructor(props: TroughFilterLargeProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  
  public render() {
    const disabled = !this.filter || !this.filter || (this.filter && Object.entries(this.filter).filter(([key, value]) => value !== undefined).length === 0) ? true : false;
    return (
      <div className="partial-filter-form pb-3">
        <div className="col-12 deselect">
          <Button
            className={classNames('btn deselect p-0 mb-3', {'disabled': disabled})}
            onClick={this.handleClick}
            disabled={disabled}
          >
            <FormattedMessage {...MESSAGES.troughFilterButton} />
          </Button>
        </div>
        <div className="partial-filter-set">
          <label className="partial-filter-set__label">
            <FormattedMessage {...MESSAGES.modelLine} />
          </label>
          <div className="partial-filter-set__btns">
            <TroughFilterFormOr fields={filterArtData()} queryKey="art"/>
          </div>
        </div>
        <div className="partial-filter-set">
          <label className="partial-filter-set__label">
            <FormattedMessage {...MESSAGES.characteristics} />
          </label>
          <div className="partial-filter-set__btns">
            <TroughFilterFormAnd fields={filterFormData()} queryKey="form" />
            <TroughFilterFormOr fields={filterOverflowData()} queryKey="overflow"/>
            <TroughFilterFormOr fields={filterBackwallData()} queryKey="backwall"/>
          </div>
        </div>
      </div>
    );
  }

  private get filter(): QueryParemeterPayload['filter'] | undefined {
    return this.props.params && this.props.params.filter;
  }
  
  private handleClick() {
    let filter: QueryParemeterPayload | {} = {};
    this.props.dispatch(removeQueryParam('filter'));
    this.props.dispatch(addFilterParam(filter));
  }
}

export const TroughFilterLarge = connect((state: GlobalPrivateState) => ({
  params: state.queryState.params,
}))(TroughFilterLargePartial);

export default TroughFilterLarge;